document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const body = document.querySelector('body');

  /********************************
   * Accordion
   *******************************/
  const initAccordions = () => {
    const accordionGroup = document.querySelectorAll('.accordion-wrap');

    if (accordionGroup.length >= 1) {
      accordionGroup.forEach(accordion => {
        const updateAccordionHeight = (item, content, inner) => {
          if (item.classList.contains('active')) {
            const currentScrollHeight = inner.scrollHeight;
            content.style.setProperty('height', currentScrollHeight + "px", 'important');
            content.style.setProperty('max-height', currentScrollHeight + "px", 'important');
          } else {
            content.style.setProperty('height', "0px", 'important');
            content.style.setProperty('max-height', "0px", 'important');
          }
        };

        // Set initial state for all items
        accordion.querySelectorAll('.accordion-item').forEach(item => {
          if (item.closest('.accordion-wrap') !== accordion) return;
          const content = item.querySelector('.accordion-description');
          const inner = item.querySelector('.accordion-inner-content');
          if (content && inner) {
            updateAccordionHeight(item, content, inner);
          }
        });

        if (accordion.classList.contains('open-first-child') && !accordion.hasAttribute('data-initialized')) {
          const initFirstChild = () => {
            // Find the first accordion item that is a DIRECT child of this accordion wrap
            const accordionItem = Array.from(accordion.querySelectorAll('.accordion-item'))
              .find(item => item.closest('.accordion-wrap') === accordion);

            if (!accordionItem) return;
            const accordionContent = accordionItem.querySelector('.accordion-description');
            if (!accordionContent) return;
            const accordionInnerContent = accordionContent.querySelector('.accordion-inner-content');
            if (!accordionInnerContent) return;

            accordionItem.classList.add('active');
            updateAccordionHeight(accordionItem, accordionContent, accordionInnerContent);
            accordion.setAttribute('data-initialized', 'true');
          };

          initFirstChild();
        }

        // Use a flag to avoid multiple listeners
        if (accordion.hasAttribute('data-listener-added')) return;
        accordion.setAttribute('data-listener-added', 'true');

        accordion.addEventListener('click', function (event) {
          const {target} = event;
          const accordionTitle = target.closest('.accordion-title');
          if (!accordionTitle) return;

          // Ensure this accordion title belongs to THIS accordion wrap and not a nested one
          if (accordionTitle.closest('.accordion-wrap') !== accordion) return;

          event.preventDefault();

          const accordionActive = accordion.querySelector('.accordion-item.active');
          const accordionItem = accordionTitle.closest('.accordion-item');
          if (!accordionItem) return;

          const accordionContent = accordionItem.querySelector('.accordion-description');
          if (!accordionContent) return;
          const accordionInnerContent = accordionContent.querySelector('.accordion-inner-content');
          if (!accordionInnerContent) return;

          if (accordionItem.classList.contains('active')) {
            accordionItem.classList.remove('active');
            accordionContent.style.setProperty('height', "0px", 'important');
            accordionContent.style.setProperty('max-height', "0px", 'important');
          } else {
            if (accordionActive && accordionActive.closest('.accordion-wrap') === accordion) {
              accordionActive.classList.remove('active');
              const activeContent = accordionActive.querySelector('.accordion-description');
              if (activeContent) {
                activeContent.style.setProperty('height', "0px", 'important');
                activeContent.style.setProperty('max-height', "0px", 'important');
              }
            }
            accordionItem.classList.add('active');
            updateAccordionHeight(accordionItem, accordionContent, accordionInnerContent);
          }
        });

        window.addEventListener('resize', () => {
          const activeItem = Array.from(accordion.querySelectorAll('.accordion-item.active'))
            .find(item => item.closest('.accordion-wrap') === accordion);

          if (activeItem) {
            const content = activeItem.querySelector('.accordion-description');
            const inner = activeItem.querySelector('.accordion-inner-content');
            if (content && inner) {
              updateAccordionHeight(activeItem, content, inner);
            }
          }
        });
      })
    }
  };

  initAccordions();

  // Robust initialization: check again on window load and after a short delay
  window.addEventListener('load', initAccordions);
  setTimeout(initAccordions, 1000);
  setTimeout(initAccordions, 3000); // Catch late-loading app content

  /********************************
   * Section feature: link
   *******************************/
  const sectionFeature = document.querySelector('.feature-product');

  if (sectionFeature) {
    const productButton = sectionFeature.querySelector('.checkout-link');
    productButton?.addEventListener('click', (event) => {
      event.preventDefault();

      if (!productButton.classList.contains('disabled')) {
        window.location.href = productButton.dataset.href;
      }
    })
  }

  /********************************
   * Link to Checkout
   *******************************/
  const checkoutLinks = document.querySelectorAll('.checkout-url');

  if (checkoutLinks.length) {
    checkoutLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        body.classList.add('cart-hidden');
        window.location.href = link.dataset.href;
      })
    });
  }

  /********************************
   * Section feature: slider
   *******************************/
  const mainSlider = document.querySelector('#main-slider_init');

  if (mainSlider && !mainSlider.classList.contains('single-slide')) {
    const thumbsSlider = document.querySelector('#thumbs-slider_init');

    const featureSliderThumbs = new Swiper(thumbsSlider, {
      slidesPerView: 3,
      breakpoints: {
        992: {
          slidesPerView: 4,
        }
      }
    });

    const featureSliderMain = new Swiper(mainSlider, {
      spaceBetween: 10,
      thumbs: {
        swiper: featureSliderThumbs,
      }
    });
  }

  /********************************
   * Section Video
   *******************************/
  const videoSection = document.querySelectorAll('.video-wrap');

  if(videoSection.length){
    videoSection.forEach(videoBox  =>{
      videoBox.addEventListener('click', ({target})=>{
        if(target.closest('.play-video')){
          const video = videoBox.querySelector('.media-video');
          if(!video) return false;
          video.play();
          videoBox.classList.add('video-played');
        }
      })
    })
  }

  const reviewsSliderInit = document.querySelector('.reviews-init_js');

  if (reviewsSliderInit) {
    new Swiper(reviewsSliderInit, {
      slidesPerView: 1.1,
      spaceBetween: 21,
      centeredSlides: true,
      speed: 1000,
      loop: true,
      preloadImages: false,
      lazy: true,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.2,
        },
        992: {
          slidesPerView: 1.4,
        },
        1200: {
          slidesPerView: 1.4,
        },
        1440: {
          slidesPerView: 1.5,
        },
        1600: {
          slidesPerView: 1.9,
        },
      }
    });
  }


  /********************************
   * Section: You May Also Like
   *******************************/
  function handleRecommendedProducts(elm, replaceSelector) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(elm);

      fetch(elm.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(replaceSelector);
            const replaceElm = elm.querySelector(replaceSelector);

            if (recommendations && recommendations.innerHTML.trim().length) {
              replaceElm.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              replaceElm.classList.add('product-recommendations--loaded');
            }

            checkInitRecommendProducts();
          })
          .catch(e => {
            console.error(e);
          });
    }

    new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 400px 0px'}).observe(elm);
  }

  const sectionsRecommendation = document.querySelectorAll('.section-recommendation');
  sectionsRecommendation.forEach(function (elm) {
    handleRecommendedProducts(elm, '.replace-items_js');
  });

  function initSwiperSlider(selector, options) {
    options = options || {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 1300,

      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },

        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    };

    return new Swiper(selector, options);
  }

  const checkInitRecommendProducts = () => {
    const productRecommendItems = Array.from(document.querySelectorAll('.section-recommendation .slider-item'));

    productRecommendItems.forEach(product => initLoopWidget(product.getAttribute('data-product-id')));

    if (window.innerWidth >= 768 && productRecommendItems.length > 3) {
      initSwiperSlider('.slider-recommendation_init');
    } else if (window.innerWidth <= 767 && productRecommendItems.length > 1) {
      initSwiperSlider('.slider-recommendation_init');
    }
  }

  /********************************
   * Widget: loop
   *******************************/
/*  const addLoopSubscriptionOnCard = () => {
    const productCardLayout = document.querySelector('.product-card-layout');
    if(!productCardLayout) return false;
    const productCardItems = productCardLayout.querySelectorAll('.product-card-layout .slider-item');

    if(productCardItems.length && !productCardLayout.closest('.section-recommendation')){
      productCardItems.forEach(product => main(product.getAttribute('data-product-id')));
    }
  }
  addLoopSubscriptionOnCard();*/

  /********************************
   * Trigger: Show filter category in collection pages
   *******************************/
  const filterTriggerSubmit = document.querySelector('.filter-trigger-submit');
  const filterCategoryWrap = document.querySelector('.filter-category-wrap');

  if (filterTriggerSubmit && filterCategoryWrap) {
    filterTriggerSubmit.addEventListener('click', () => {
      if(!filterCategoryWrap.classList.contains('active')){
        filterCategoryWrap.classList.add('active');
        filterCategoryWrap.style.height = `${filterCategoryWrap.scrollHeight}px`;
      }else{
        filterCategoryWrap.classList.remove('active');
        filterCategoryWrap.style.height = `${0}px`;
      }
    });

    // Reset mobile dropdown state when viewport crosses into desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        filterCategoryWrap.classList.remove('active');
        filterCategoryWrap.style.height = '0px';
      }
    });
  }

  /********************************
   * Section: Video slider
   *******************************/
  const nodeSlicerSelectors = {
    container: '[js-video-slider="container"]',
    slider: '[js-video-slider="wrapper"]',
    navigation: '[js-video-slider="navigation"]',
    prev: '[js-video-slider="prev"]',
    next: '[js-video-slider="next"]',
    soundBtn: '[js-video-slider="sound"]',
  }

  function initSlider() {
    let slidersContainers = document.querySelectorAll(nodeSlicerSelectors.container);

    slidersContainers.forEach(function (container, index) {
      let sliderEl = container.querySelector(nodeSlicerSelectors.slider)
      let sliderNav = container.querySelector(nodeSlicerSelectors.navigation)

      const videoSlider = new Swiper(sliderEl, {
        slidesPerView: 1.27,
        spaceBetween: 15,
        cssMode: true,
        centeredSlides: true,
        loop: false,
        centeredSlidesBounds: true,
        navigation: {
          nextEl: container.querySelector(nodeSlicerSelectors.next),
          prevEl: container.querySelector(nodeSlicerSelectors.prev),
        },
        breakpoints: {
          767: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            slidesPerView: 2,
          },
          1000: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            slidesPerView: 3,
          },
          1100: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            cssMode: false,
            slidesPerView: 3,
            spaceBetween: 15
          },
          1500: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            cssMode: false,
            slidesPerView: 4,
            spaceBetween: 15
          }
        }
      });

      videoSlider.on('slideChange', function () {
        sliderEl.querySelectorAll('.swiper-slide').forEach(function(slide) {
          const buttonPlay = slide.querySelector('.play-video');
          if(buttonPlay.classList.contains('active')){
            buttonPlay.click();
          }
          buttonPlay.classList.remove('active');
        });
      });

      document.querySelectorAll('.play-video').forEach(function(button) {
        button.addEventListener('click', function() {
          button.classList.toggle('active');
          const overlay = sliderEl.querySelector('.overlay');
          if (overlay) {
            console.log('click overlay')
            overlay.style.display = overlay.style.display === 'none' ? 'block' : 'none';
          }
        });
      });

    })
  }

  if (document.querySelectorAll(nodeSlicerSelectors.container).length) {
    initSlider()
  }

  /********************************
   * Play video
   *******************************/
  const nodeVideoPlaySelectors = {
    container: '[js-big-video="container"]',
    video: '[js-big-video="video"]',
    soundBtn: '[js-big-video="sound"]',
    playBtn: '[js-big-video="play"]',
  }

  function initVideoPlay() {
    const videosSections = document.querySelectorAll(nodeVideoPlaySelectors.container)

    function stopAllExcept(activeSection) {
      videosSections.forEach(function(section) {
        if (section === activeSection) return;
        const v = section.querySelector(nodeVideoPlaySelectors.video);
        const btn = section.querySelector(nodeVideoPlaySelectors.playBtn);
        if (v && !v.paused) {
          v.pause();
          v.muted = true;
        }
        if (btn) btn.classList.add('paused');
      });
    }

    videosSections.forEach(function (section){
      let video = section.querySelector(nodeVideoPlaySelectors.video)
      let playVideoBtn = section.querySelector(nodeVideoPlaySelectors.playBtn)
      let soundVideoBtn = section.querySelector(nodeVideoPlaySelectors.soundBtn)

      if(soundVideoBtn){
        soundVideoBtn.addEventListener('click', () => {
          if( video.muted ) {
            video.muted = false
            soundVideoBtn.classList.add('unmuted')
          } else {
            video.muted = true
            soundVideoBtn.classList.remove('unmuted')
          }
        })
      }

      if(playVideoBtn){
        playVideoBtn.addEventListener('click', () => {
          if( video.paused ) {
            stopAllExcept(section)
            video.play()
            video.muted = false
            playVideoBtn.classList.remove('paused')
          } else {
            video.pause()
            playVideoBtn.classList.add('paused')
          }
        })
      }

      video.onloadeddata = function() {
        playVideoBtn.classList.remove('paused');
      };
    })
  }

  if (document.querySelectorAll(nodeVideoPlaySelectors.container).length) {
    initVideoPlay()
  }
});